module.exports = __webpack_public_path__ + "img/r-cb6-100-2.52ead4d3.gif";